import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./Congratulation.css";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import { StudentTopbar } from "../TopBar/TopBar";
import { StudentMapMenuLight } from "../Map/MapMenu/MapMenuLight";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import UnlockCertificatePopup from "../../../common/AuthV2/UnlockCertificatePopup";
export const StudentAdminTrophyCongo = () => {
  const { student, fetchWithAuthStudent } = useAuthStudent();
  const apiUrl = process.env.REACT_APP_API_URL;
  const { questId, chapterId } = useParams();
  const [trophies, setTrophies] = useState(null);
  const { user } = useAuth();
  const currentUser = user?.user || student?.student;
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;
  const [showUnlockPopup, setShowUnlockPopup] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    if (!student || !student.student) {
      return;
    }

    const fetchTrophies = async () => {
      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/trophy/show/${questId}`,
          {
            method: "GET",
          },
        );

        const data = await response.json();
        setTrophies(data?.trophy_file_url);
      } catch (err) {
      } finally {
      }
    };

    fetchTrophies();
  }, [student, fetchWithAuthStudent, apiUrl, questId]);

  useEffect(() => {
    const fetchQuestData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/kid-quiz-progress/${student?.student?.id}/${chapterId}/${questId}`,
          {
            method: "GET",
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch quiz progress");
        }

        const data = await response.json();
        if (data.canAwardCertificate === true) {
          awardCertificate(student?.student?.id, questId, chapterId);
        }
      } catch (error) {}
    };

    fetchQuestData();
  }, [apiUrl, student, chapterId, questId, fetchWithAuthStudent]);
  const awardCertificate = async (studentId, questId, chapterId) => {
    if (!student || !student.token) {
      return;
    }

    const formData = new FormData();
    formData.append("studentId", studentId);
    formData.append("questId", questId);
    formData.append("chapterId", chapterId);

    try {
      const response = await fetchWithAuthStudent(
        `${apiUrl}/student/award-certificate`,
        {
          method: "POST",
          body: formData, // Sending as form-data
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to award certificate");
      }
    } catch (error) {}
  };

  const handleProtectedClick = (e) => {
    // ❌ Not logged in → Login modal
    if (!currentUser) {
      e.preventDefault();
      setShowAuthModal(true);
      return;
    }

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    // 🔒 Not subscribed → show THIS popup
    if (!isSubscribed) {
      e.preventDefault();
      setShowUnlockPopup(true);
      return;
    }

    // ✅ Subscribed → allow navigation
  };
  return (
    <div
      style={{
        backgroundImage:
          "url('https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/trophy/trophybackground.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="d-flex justify-content-center align-items-center min-vh-100"
    >
      <div className="container-fluid">
        <div style={{ position: "absolute" }}>
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/trophy/trophygetbackground.png"
            alt="background"
            className="fullscreen-image"
          />
        </div>
        <div
          className="text-center center-content"
          style={{ marginTop: "40px" }}
        >
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/trophy/Congratulations.png"
            alt="Congratulations"
            className="img-fluid responsive-img"
          />
          <p className="text-white mb-0">you have unlocked a trophy</p>
        </div>

        <div
          style={{
            position: "relative",
            bottom: "0px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {isSubscribed ? (
            <img
              src={trophies}
              alt="trophy"
              className="img-fluid trophy-responsive"
              style={{
                marginBottom: "-40px",
                // width: "10vw",
                zIndex: "8",
                height: "10%",
              }}
            />
          ) : (
            ""
          )}

          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              className="w-100 mt-4 trophytable"
              style={{ marginBottom: "0px" }}
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/congratulations/trophy/Table1.png"
              alt="table"
            />

            <div
              style={{
                position: "absolute",
                top: "100px", // 20px from the top of the image
                left: "50%",
                transform: "translateX(-50%)", // center horizontally
              }}
            >
              <Link
                style={{
                  background:
                    "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                  color: "#333333",
                  borderRadius: "40px",
                  padding: "10px 30px",
                  fontSize: "15px",
                  fontWeight: "600",
                  display: "inline-block",
                  textDecoration: "none",
                  width: "max-content",
                }}
                to={isSubscribed ? "/student/admin/trophy" : "#"}
                onClick={handleProtectedClick}
              >
                View Trophy room
              </Link>
            </div>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 4 }}>
          <StudentMapMenuLight />
        </div>
      </div>

      <UnlockCertificatePopup
        modalTitle="HURRAY! FESTIVAL COMPLETED"
        modalDesc="Your Trophy is Ready."
        showModal={showUnlockPopup}
        handleClose={() => setShowUnlockPopup(false)}
      />
    </div>
  );
};
